module.exports = __webpack_public_path__ + "static/img/Craig-Fitzgibbon.423448d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Craig-Fitzgibbon.jpg
// module id = 1xFB
// module chunks = 0